import React, { useEffect, useMemo, useState } from "react";

/**
 * RatingConfetti — small gold particle burst anchored to a container.
 * Renders when `fireKey` changes. Auto-cleans after ~1.6s.
 */
export default function RatingConfetti({ fireKey }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!fireKey) return;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 1650);
    return () => clearTimeout(t);
  }, [fireKey]);

  const pieces = useMemo(() => {
    return Array.from({ length: 26 }).map(() => {
      const angle = Math.random() * Math.PI * 2;
      const distance = 80 + Math.random() * 140;
      return {
        color: ["#c39d2b", "#e5c65b", "#722f37", "#f4ead0"][Math.floor(Math.random() * 4)],
        tx: Math.cos(angle) * distance,
        ty: Math.sin(angle) * distance - 20,
        rotate: 180 + Math.random() * 540,
        delay: Math.random() * 120,
        width: 4 + Math.random() * 5,
        height: 6 + Math.random() * 8,
      };
    });
  }, [fireKey]);

  if (!visible) return null;
  return (
    <div className="pointer-events-none absolute inset-0 overflow-visible" aria-hidden data-testid="rating-confetti">
      <div className="absolute left-1/2 top-1/2 w-0 h-0">
        {pieces.map((c, i) => (
          <span
            key={i}
            className="reveal-confetti-piece"
            style={{
              background: c.color,
              width: c.width,
              height: c.height,
              animationDelay: `${c.delay}ms`,
              "--tx": `${c.tx}px`,
              "--ty": `${c.ty}px`,
              "--r": `${c.rotate}deg`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
